/**
 * AlmadarPostDigitalSovereigntyAlmadarProposalSLPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostDigitalSovereigntyAlmadarProposalSLPostPage
 */

import { useAlmadarPostDigitalSovereigntyAlmadarProposalSLPostPageLogic } from '@/hooks/traits/useAlmadarPostDigitalSovereigntyAlmadarProposalSLPostPageLogic';
import type { AlmadarPostDigitalSovereigntyAlmadarProposalSLPostPageConfig } from '@/hooks/traits/useAlmadarPostDigitalSovereigntyAlmadarProposalSLPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostDigitalSovereigntyAlmadarProposalSLPostView as AlmadarPostDigitalSovereigntyAlmadarProposalSLPostViewEntity } from '@app/shared';
import { AlmadarPostDigitalSovereigntyAlmadarProposalSLPostFooterView } from '@/components/traits/AlmadarPostDigitalSovereigntyAlmadarProposalSLPostFooterView';
import { Container } from '@almadar/ui/components';
import { Box } from '@almadar/ui/components';
import { AlmadarPostDigitalSovereigntyAlmadarProposalSLPostView } from '@/components/traits/AlmadarPostDigitalSovereigntyAlmadarProposalSLPostView';
import { AlmadarPostDigitalSovereigntyAlmadarProposalSLPostHeaderView } from '@/components/traits/AlmadarPostDigitalSovereigntyAlmadarProposalSLPostHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostDigitalSovereigntyAlmadarProposalSLPostPageViewProps {
  config?: Partial<AlmadarPostDigitalSovereigntyAlmadarProposalSLPostPageConfig>;
}

export function AlmadarPostDigitalSovereigntyAlmadarProposalSLPostPageView({ config: propsConfig }: AlmadarPostDigitalSovereigntyAlmadarProposalSLPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostDigitalSovereigntyAlmadarProposalSLPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostDigitalSovereigntyAlmadarProposalSLPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostDigitalSovereigntyAlmadarProposalSL" trait="AlmadarPostDigitalSovereigntyAlmadarProposalSLPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostDigitalSovereigntyAlmadarProposalSLPostPage">{slotWriter['main'] === 'INIT' ? (<Stack gap="none" direction="vertical"><AlmadarPostDigitalSovereigntyAlmadarProposalSLPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box fullWidth={true} bg="transparent" paddingY="xl"><Container padding="lg" size="xl" maxWidth="xl"><AlmadarPostDigitalSovereigntyAlmadarProposalSLPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostDigitalSovereigntyAlmadarProposalSLPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostDigitalSovereigntyAlmadarProposalSLPostPageView;
